<template>
  <div>
    <vs-popup :title="$t('ShipmentInfo')" :active.sync="showModal">
      <div
        class="vx-row mb-6 flex w-full"
        style="direction: ltr"
        v-if="model || editModel"
      >
        <div class="flex gap-5 w-full mr-4">
          <div class="w-1/2">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{
                $t("Transport Mode")
              }}</label>

              <v-select
                class="mt-3"
                label="name"
                :options="transportModes"
                v-model="model.transportMode"
                :reduce="(x) => x.id"
                dir="rtl"
              >
              </v-select>
            </div>
            <div class="vx-col w-full my-3">
              <label class="vs-select--label ">{{
                $t("Port Of Discharge")
              }}</label>
              <vs-input v-model="model.portOfDischarge" class="mt-3" />
            </div>
            <div class="vx-col w-full my-3">
              <label class="vs-select--label">Origin Of Goods Country</label>
              <v-select
                label="name"
                name="countryOfOriginOfGoods"
                :options="allCountries"
                v-validate="{ required: true }"
                :clearable="false"
                :reduce="(x) => ({ id: x.id, name: x.name })"
                ref="countryInfoCommandOfOriginOfGoodsSelect"
                class="mt-3"
                v-model="model.countryInfoCommandOfOriginOfGoods"
                dir="rtl"
              >
             </v-select>
            </div>
            <div class="vx-col w-full my-3">
              <label class="vs-select--label ">Beneficiary Country</label>
              <v-select
                label="name"
                name="countryOfBeneficiary"
                :options="allCountries"
                v-validate="{ required: true }"
                :clearable="false"
                :reduce="(x) => ({ id: x.id, name: x.name })"
                ref="countryInfoCommandOfBeneficiarySelect"
                class="mt-3"
                v-model="model.countryInfoCommandOfBeneficiary"
                dir="rtl"
              >
              </v-select>
            </div>

            <div class="vx-col w-full my-3">
              <label class="vs-select--label"
                >Place Of Destination Country</label
              >
              <v-select
                label="name"
                name="countryOfDestination"
                :options="allCountries"
                v-validate="{ required: true }"
                :clearable="false"
                :reduce="(x) => ({ id: x.id, name: x.name })"
                ref="countryInfoCommandPlaceOfDestinationSelect"
                class=" mt-3"
                v-model="model.countryInfoCommandPlaceOfDestination"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>

          <div class="w-1/2">
            <div class="vx-col w-full">
              <label class="vs-select--label  ">{{
                $t("Port Of Loading")
              }}</label>
              <vs-input v-model="model.portOfLoading" class="mt-3" />
            </div>
            <div class="vx-col w-full my-3">
              <label class="vs-select--label  ">{{
                $t("Final Place Delivery")
              }}</label>
              <vs-input v-model="model.finalPlaceDelivery" class="mt-3" />
            </div>
            <div class="vx-col w-full my-3">
              <label class="vs-select--label  ">{{
                $t("Shipping Marks")
              }}</label>
              <vs-input v-model="model.shippingMarks" class="mt-3" />
            </div>
            <div class="vx-col w-full my-3">
              <label class="vs-select--label ">{{
                $t("Freight Charge")
              }}</label>
              <vs-input
            
                type="number"
                v-model="model.freightCharge"
                class=" charge mt-3"
                name="rate"
              />
            </div>
            <div class="vx-col w-full my-5 ">
             
              <label class="vs-select--label">{{
                $t("Terms Of Delivery")
              }}</label>

              <v-select
                class="mt-3"
                label="name"
                :options="termOfDeliveries"
                v-model="model.termsOfDelivery"
                :reduce="(x) => x.id"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>
        </div>

        <div class="vx-col w-full">
          <vs-checkbox
            :checked="model.partialAllowed"
            @click="isHasMember($event)"
            class="mt-2 gap-5"
            >{{ $t("Partial Allowed") }}
          </vs-checkbox>
        </div>
        <div class="flex justify-start w-full">
          <vs-button
            type="filled"
            v-has-permission="'UpdateShipmentInfo'"
            class="mb-3 mt-5"
            :disabled="
              !model.countryInfoCommandPlaceOfDestination ||
              !model.transportMode ||
              !model.portOfLoading ||
              !model.portOfDischarge ||
              !model.finalPlaceDelivery ||
              !model.shippingMarks ||
              !model.termsOfDelivery ||
              !model.freightCharge ||
              !model.countryInfoCommandOfBeneficiary ||
              !model.countryInfoCommandOfOriginOfGoods
            "
            @click.prevent="submitForm"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss">
body[dir="rtl"] .vs-popup--content {
  overflow-y: scroll !important;
}
body[dir="rtl"]  .charge{ 
  .vs-con-input{
   .vs-input--input.normal{
  
  padding: .7rem !important;

}
  }

}
.vs-inputx .vs-input--input{
  height: 40px !important;
}
.vdp-datepicker div input {
  width: 100%;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";

const dict = {
  custom: {
    // TargetCurrencyType: {
    //   required: "لطفا ارز مقصد را وارد نمایید.",
    // },
    currencyType: {
      required: "لطفا ارز مبدا را وارد نمایید.",
    },
    bPrice: {
      required: "لطفا نرخ را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  components: {
    "v-select": vSelect,
    Datepicker,
  },
  props: {
    show: { default: false },
    editModel: {},
  },
  data() {
    return {
      departman: "",
      popupTitle: "",
      disabled: false,
      model: {
        partialAllowed: false,
        locationInfo: {},
      },
      price: null,
      transportModes: [
        { name: "زمینی", id: 1 },
        { name: "دریایی", id: 2 },
        { name: "هوایی", id: 3 },
      ],
      termOfDeliveries: [
        { name: "EXW", id: 1 },
        { name: "FCA", id: 2 },
        { name: "FAS", id: 3 },
        { name: "FOB", id: 4 },
        { name: "CFR", id: 5 },
        { name: "CIF", id: 6 },
        { name: "CPT", id: 7 },
        { name: "CIP", id: 8 },
        { name: "DAP", id: 9 },
        { name: "DPU", id: 10 },
        { name: "DDP", id: 11 },
      ],
    };
  },
  computed: {
    showModal: {
      get: function () {
        this.model.purchaseInvoiceId = this.$route.params.id;

        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
    ...mapGetters({
      allCountries: "country/countryList",
      // locationInfo: "country/details",
    }),
  },
  mounted() {
    this.fetchCountry();
  },
  methods: {
    ...mapActions({
      updateShipmentInfo: "purchaseInvoice/updateShipmentInfo",
      fetchCountry: "country/fetchCountry",
    }),
    isHasMember(val) {
      if (val.target.checked) this.model.partialAllowed = true;
      else this.model.partialAllowed = false;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model.locationInfo = {
            countryInfoCommandOfBeneficiary: {
              id: this.model.countryInfoCommandOfBeneficiary.id,
              name: this.model.countryInfoCommandOfBeneficiary.name,
            },
            countryInfoCommandOfOriginOfGoods: {
              id: this.model.countryInfoCommandOfOriginOfGoods.id,
              name: this.model.countryInfoCommandOfOriginOfGoods.name,
            },
            countryInfoCommandPlaceOfDestination: {
              id: this.model.countryInfoCommandPlaceOfDestination.id,
              name: this.model.countryInfoCommandPlaceOfDestination.name,
            },
          };
          console.log(this.model);
          this.updateShipmentInfo(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000,
            });

            this.$emit("finish");
            this.model = {};
            this.price = null;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.editModel) {
          this.model = this.editModel;
          console.log(this.model);
          this.model.countryInfoCommandOfBeneficiary =
            this.model.locationInfo.countryInfoQueryOfBeneficiary;
          this.model.countryInfoCommandOfOriginOfGoods =
            this.model.locationInfo.countryInfoQueryOfOriginOfGoods;
          this.model.countryInfoCommandPlaceOfDestination =
            this.model.locationInfo.countryInfoQueryPlaceOfDestination;
        }
      }
    },
  },
};
</script>
